import {
    TenderContractsAllComponent,
    TenderContractsAwaitingBidsComponent,
    TenderContractsAwardedComponent
} from '../../../../../../pages';
import {
    TenderBidsResolver,
    TenderContractBidsAnalysisResolver,
    TenderContractsAwaitingBidsResolver, TenderContractsAwardedResolver
} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const contractsAwardedRoute: Route = {
    path: 'awarded',
    component: TenderContractsAwardedComponent,
    resolve: {
        offers: TenderContractsAwardedResolver,
    },
};
